import classNames from 'classnames';
import { Link } from 'react-router-dom';
var classes = {
    base: 'cursor-pointer font-medium text-brand-01 underline transition-colors hover:text-brand-02 dark:text-white',
    size: {
        xs: 'text-xs',
        sm: 'text-sm',
        base: 'text-base',
        lg: 'text-lg',
        xl: 'text-xl',
    },
};
var StyledLink = function (_a) {
    var to = _a.to, _b = _a.size, size = _b === void 0 ? 'base' : _b, children = _a.children, className = _a.className;
    return (<Link to={to} className={classNames(classes.base, classes.size[size], className)}>
      {children}
    </Link>);
};
export default StyledLink;
